import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as API } from '../../../axiosConfig';
import { getEncodedURL } from '../../../utils/utils';

const URL =
  'payment-options-proxy?endpoint=paymentdashboard/legacy/maintenance-rule';

const SLICE_NAME = 'legacyPaymentOptionsMaintenanceSchedule';
const LIST_LEGACY_PAYMENT_OPTIONS_MAINTENANCE_SCHEDULE = `${SLICE_NAME}/maintenance-schedule/list`;
const CREATE_LEGACY_PAYMENT_OPTIONS_MAINTENANCE_SCHEDULE = `${SLICE_NAME}/maintenance-schedule/create`;
const DELETE_LEGACY_PAYMENT_OPTIONS_MAINTENANCE_SCHEDULE = `${SLICE_NAME}/maintenance-schedule/delete`;

export const getLegacyMaintenanceScheduleList = createAsyncThunk(
  LIST_LEGACY_PAYMENT_OPTIONS_MAINTENANCE_SCHEDULE,
  async (_, { rejectWithValue }) => {
    try {
      const {
        data: { rules = [] },
      } = await API.get(URL);

      return rules;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createLegacyMaintenanceSchedule = createAsyncThunk(
  CREATE_LEGACY_PAYMENT_OPTIONS_MAINTENANCE_SCHEDULE,
  async (payload) => {
    const response = await API.post(URL, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const deleteLegacyMaintenanceSchedule = createAsyncThunk(
  DELETE_LEGACY_PAYMENT_OPTIONS_MAINTENANCE_SCHEDULE,
  async (data) => {
    const response = await API.delete(URL, { data }).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

const initialState = {
  maintenanceScheduleList: [],
  maintenanceScheduleListStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
};

const legacyPaymentOptionsMaintenanceScheduleSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLegacyMaintenanceScheduleList.pending, (state) => {
        state.maintenanceScheduleListStatus = 'loading';
      })
      .addCase(getLegacyMaintenanceScheduleList.rejected, (state) => {
        state.maintenanceScheduleList = [];
        state.maintenanceScheduleListStatus = 'failed';
      })
      .addCase(
        getLegacyMaintenanceScheduleList.fulfilled,
        (state, { payload }) => {
          state.maintenanceScheduleList = payload;
          state.maintenanceScheduleListStatus = 'succeeded';
        },
      );
  },
});

export const legacyPaymentOptionsMaintenanceScheduleActions =
  legacyPaymentOptionsMaintenanceScheduleSlice.actions;

export const selectMaintenanceScheduleList = (state) =>
  state.legacyPaymentOption.maintenanceSchedule.maintenanceScheduleList;

export const selectIsLoadingMaintenanceScheduleList = (state) =>
  state.legacyPaymentOption.maintenanceSchedule
    .maintenanceScheduleListStatus === 'loading';

export default legacyPaymentOptionsMaintenanceScheduleSlice.reducer;
